
import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { Urls } from '../../../apiConnection/urls';
import { CategoryFormComponent } from '../category-form/category-form.component';
import { CustomDeleteComponent } from '../../../components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './category-list.page.html',
  styleUrl: './category-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class CategoryListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  loading = false;

  public url = Urls.urls.categories;

  public headers = [
    { name: 'Número', key: 'code' },
    { name: 'Nombre', key: 'name' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CategoryFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'familia';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
